<script setup>
import { computed } from 'ui.vue3';
import EnterpriseIcon from './Icons/EnterpriseIcon.vue';
import InfoIcon from './Icons/InfoIcon.vue';

const props = defineProps({
  modifiers: {
    type: Array,
    default: [],
  },
});

const classes = computed(() => {
  const base = 'cloud-calculator__info';
  const result = [base];
  for (const modifier of props.modifiers) {
    result.push(`${base}_${modifier}`);
  }
  return result;
});

const showInfoIcon = computed(() => props.modifiers.includes('info'));

const showEnterpriseIcon = computed(() => props.modifiers.includes('enterprise'));

const iconInverted = computed(() => props.modifiers.includes('mark') && !props.modifiers.includes('icon-inverted'));
</script>

<template>
  <div role="alert" :class="classes">
    <InfoIcon v-if="showInfoIcon" :inverted="iconInverted"/>
    <EnterpriseIcon v-if="showEnterpriseIcon" :inverted="iconInverted"/>
    <div class="cloud-calculator__info-content">
      <slot/>
    </div>
  </div>
</template>
